module.exports = __webpack_public_path__ + "static/img/CompanyPhoto.0722c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/CompanyPhoto.jpg
// module id = ku4+
// module chunks = 1